import { Link } from 'react-router-dom';
import type { Movie } from '@/types';

interface Props {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: Props) {
  return (
    <Link to={`/movie/${movie.id}`} className="group block">
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200 border border-background-300/50">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 高清电影在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent opacity-90"></div>

        {typeof rank === 'number' && (
          <span
            className={`absolute top-0 left-0 w-9 h-9 flex items-center justify-center font-label text-xl rounded-br-lg ${
              rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-black/70 text-foreground-900'
            }`}
          >
            {rank}
          </span>
        )}

        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-black/70 text-primary-400 text-xs font-semibold">
          {movie.rating.toFixed(1)}
        </span>

        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-2xl text-background-50"></i>
          </span>
        </span>

        <div className="absolute bottom-0 left-0 right-0 p-2.5">
          <h3 className="text-sm font-semibold text-white truncate">{movie.title}</h3>
          <p className="text-xs text-foreground-400 truncate mt-0.5">
            {movie.year} · {movie.region}
          </p>
        </div>
      </div>
    </Link>
  );
}